import { WEBHOST_APP_UID, createEwmRoute, } from '@assetmark/ewm30-routing-shell';
import { SigninRedirectPage } from '../pages/SigninRedirectPage';
import { hardcodedRouteCollector } from './hardcodedRouteCollector';
export const ewmAppRoutesCollector = async () => {
    const accountdataRoutesModulePromise = import('accountdata_routes/AccountDataRoutes').catch((e) => {
        console.error(e);
        console.error('[accountdata] Failed to load routes! Client section will not be available.');
        return { getRoutes: () => ({ routes: [], routeMasks: [] }) };
    });
    const insightsRoutesModulePromise = import('insights_routes/InsightsRoutes').catch((e) => {
        console.error(e);
        console.error('[insights] Failed to load routes! Advisor Insights will not be available.');
        return { getRoutes: () => ({ routes: [], routeMasks: [] }) };
    });
    const [accountdataRoutesModule, insightsRoutesModule] = await Promise.all([
        accountdataRoutesModulePromise,
        insightsRoutesModulePromise,
    ]);
    return (rootRoute, resolver) => {
        const { routes: clientSectionRoutes, routeMasks: clientSectionRouteMasks } = accountdataRoutesModule.getRoutes(rootRoute, resolver);
        const { routes: insightsRoutes, routeMasks: insightsRouteMasks } = insightsRoutesModule.getRoutes(rootRoute, resolver);
        const { routes: hardcodedRoutes, routeMasks: hardcodedRouteMasks } = hardcodedRouteCollector(rootRoute, resolver);
        const signinRedirectRoute = createEwmRoute({
            getParentRoute: () => rootRoute,
            path: 'signin-redirect',
            component: SigninRedirectPage,
            beforeLoad: () => ({
                appUid: WEBHOST_APP_UID,
                getTitle: () => 'Sign-in Redirect',
                getTags: () => [],
                disableEwmHistory: true,
            }),
        });
        return {
            routes: [
                signinRedirectRoute,
                ...clientSectionRoutes,
                ...insightsRoutes,
                ...hardcodedRoutes,
            ],
            routeMasks: [
                ...clientSectionRouteMasks,
                ...insightsRouteMasks,
                ...hardcodedRouteMasks,
            ],
        };
    };
};
